import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { getLBannerHeight, getLBannerWidth } from './lBanner.utils';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const left = getLBannerWidth();
  const bottom = getLBannerHeight();

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    visible: false,
    zIndex: 3,
    shader: {
      // NOTE: adding a pixel to ensure sub-pixel offset compensation in GLSL shader
      x: left + 1,
      y: 0,
      w: SCREEN_WIDTH[screenSize] - left - 1,
      h: SCREEN_HEIGHT[screenSize] - bottom - 1,
    },
  };
};
